<template>
   <dd-validation-rules-wrapper :name="name" :rules="rules" :error="errorData">
    <template #default="validationWrapperProps">
      <validation-provider ref="provider" :name="name" :rules="validationWrapperProps.rules" v-slot="validationProps">
        <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
            :provider-ref="$refs.provider"
            v-slot="{validateInput}"
        >
          <div class="license-plate-component">
            <div class="input-group-addon">
              <img src="/img/dutch_license_plate.png"/>
            </div>
            <input
                :data-dusk="dataDusk"
                v-model="kenteken"
                ref="kentekenInput"
                v-bind="$attrs"
                @input="debouncedValidation()"
                @blur="validateInput"
                type="text"
            >
          </div>
        </dd-input-wrapper>
      </validation-provider>
    </template>
   </dd-validation-rules-wrapper>
</template>

<script>
import licensePlateApi from '~/api/licenseplate';
import _ from 'lodash';

export default {
  name: "LicensePlateInput",
  emits: ['vehicle'],
  props: {
    dataDusk: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    modifyValues: {
      type: Boolean,
      required: false,
      default: true,
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
  },
  data() {
    return {
      timer: null,
      vehicleData: {},
      errorData: '',
      kenteken: this.value,
      debouncedValidation: _.debounce(this.validateKenteken, 500),
    }
  },
  watch: {
    vehicleData() {
      if (this.modifyValues) {
        this.setVehicleDataField();
      }
    }
  },
  methods: {
    setVehicleDataField() {
      Object.entries(this.vehicleData).forEach(([key,value]) => {
        let field = document.querySelector(`.form-input input.${key}`)
        if (!field || field.value) return;
        field.value = value;
        // Manually trigger an input event to notify Vue.js of the change
        const event = new Event('input', {
          bubbles: true,
          cancelable: true,
        });
        field.dispatchEvent(event);
      });
    },
    emitKentekenUpdate() {
      this.$emit('input', this.kenteken);
    },
    validateKenteken() {
      licensePlateApi.validate(this.kenteken).then(res => {
        if ("error" in res) {
          this.errorData = "Ongeldig kenteken";
          this.emitKentekenUpdate();
        }
        else {
          this.kenteken = res.formatted;
          this.emitKentekenUpdate();
          this.errorData = "";
          licensePlateApi.vehicle(this.kenteken).then(vehicleData => {
            this.$emit('vehicle', vehicleData);
            this.vehicleData = vehicleData
          } );
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.license-plate-component {
  display: flex;

  .input-group-addon {
    flex-grow: 1;
    flex-shrink: 0;
    background-color: #2463A8;
    border: 0;
    padding: 5px 10px;
    width: 34px;
    img {
      height: 24px;
    }
  }

  input {
    flex-shrink: 1;
    flex-grow: 0;
    width: 100%;
    background-color: #F5BD04;
    border: 0;
    padding-left: $spacing-md;
    height: 39px;
    padding-right: $spacing-md;
    font-family: 'Kenteken';
    font-weight: 600;
    text-transform: uppercase;
    border-top-right-radius: $border-radius-base;
    border-bottom-right-radius: $border-radius-base;
    color: rgb(45, 44, 44);
  }

  &.invalid {
    border: solid 2px red;
    border-radius: 4px;

    input {
      color: red;
    }
  }
}

</style>
